import ModalController from "../modal_controller"

// Modal potwierdzenia wystawienia korekty/faktury końcowej do dokumentu
// niewysłanego do KSeF. Trigger: link z data-ksef-dependent-confirm
// (wartość wybiera wariant treści); OK nawiguje pod href triggera.
export default class extends ModalController {
  static targets = [...ModalController.targets, "variant"]

  url = null

  open(event) {
    event.preventDefault()
    this.url = event.currentTarget.getAttribute("href")
    const kind = event.currentTarget.dataset.ksefDependentConfirm
    this.variantTargets.forEach(el => el.classList.toggle("hidden", el.dataset.kind !== kind))
    super.open()
  }

  confirm() {
    if (this.url) window.location.href = this.url
  }
}
